const trunkPain=[

    {
    label:"Site(s)",
    controlType:"radio button",
    options:["Right", "Left", "Central"]
    },

    {
    label:"Severity",
    controlType:"radio button",
    options:["Mild", "Moderate", "Severe"]   
    },

    {
    label:"Character",
    controlType:"radio button",
    options:["Dull", "Sharp", "Crampy"]   
    },

    {
    label:"When present",
    controlType:"radio button",
    options:["Constant","Intermittent"]
    },
 
    
    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Evey week or two", "Occasionally"]
    },

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default trunkPain



